import { ControlBase } from './control-base';
export class MetadataDateTime extends ControlBase<string> {
    override controlType = 'dateTime';
}
